import { Component, Input, OnInit } from '@angular/core';
import { PurchaseOrderDto } from '@app/models/purchase-order.model.dto';
import { Shipment } from '@models/shipment.model';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CompanyService } from '@services/company.service';
import { ShipmentService } from '@services/shipment.service';
import { SweetAlertService } from '@services/sweet-alert.service';
import { Toaster } from '@services/toaster.service';
import { LocalStorage } from 'ngx-webstorage';
import { ShipmentTrackingDetailComponent } from '../shipment-tracking-detail/shipment-tracking-detail.component';
import { ShipmentTrackingFormModalComponent } from '../shipment-tracking-form-modal/shipment-tracking-form-modal.component';
import { environment } from '@env/environment';

@Component({
  selector: 'ngx-shipment-tracking',
  templateUrl: './shipment-tracking.component.html',
  styleUrls: ['./shipment-tracking.component.scss'],
})
export class ShipmentTrackingComponent implements OnInit {
  public canAddShipments: boolean = false;
  @Input() products = [];
  @Input() allowEdit: boolean = true;
  @Input() companyType: string;
  @LocalStorage() organizationId: string;
  shipments: Shipment[];

  constructor(private shipmentService: ShipmentService,
              private router: Router,
              private $toaster: Toaster,
              private sweetAlert: SweetAlertService,
              private $company: CompanyService,
              private $modal: NgbModal) {
  }
  isRCDSS = environment.name === 'rcdss';
  public _purchaseOrder: PurchaseOrderDto = null;

  public get purchaseOrder(): PurchaseOrderDto {
    return this._purchaseOrder;
  }

  @Input()
  public set purchaseOrder(po: PurchaseOrderDto) {
    this._purchaseOrder = new PurchaseOrderDto(po);
    this.canAddShipments = this._shouldEnableShipments(this._purchaseOrder);
  }

  ngOnInit() {
    this.getShipments();
  }

  removeShipment(shipmentId) {
    this.sweetAlert.deleteConfirmation()
      .then((result) => {
        if (result.value) {
          this.shipmentService.deletePurchaseOrderShipment(this.purchaseOrder.id, shipmentId).subscribe(() => {
            this.$toaster.show('success', 'Success', 'Shipment Tracking removed');
            this.getShipments();
          }, (e) => {
            this.$toaster.show('error', 'Error', e.error.message);
          });
        }
      });
  }

  openAddShipmentModal() {
    const modalRef = this.$modal.open(ShipmentTrackingFormModalComponent, {
      size: 'xl',
      container: 'nb-layout',
    });
    modalRef.componentInstance.shipments = this.shipments;
    modalRef.componentInstance.products = this.products;
    modalRef.componentInstance.purchaseOrder = this.purchaseOrder;
    modalRef.result.then((shipment) => {
      this.getUpdatedPoData();
      this.getShipments();
    }, () => {
    });
  }

  getShipments() {
    this.shipmentService.getPurchaseOrderShipments(this.purchaseOrder.supplier_id, this.purchaseOrder.id)
      .subscribe(shipments => {
        this.shipments = shipments;
      });
  }

  getUpdatedPoData() {
    this.$company.purchaseOrder(this.purchaseOrder.id)
      .subscribe((result) => {
        this.purchaseOrder = result;
      });
  }

  showDetail(shipmentId) {
    this.shipmentService.getShipmentPORelated(this.organizationId, this.purchaseOrder.id, shipmentId)
      .subscribe((shipment) => {
        if (shipment.enhanced_tracking_identifier) {
          const url = this.router.createUrlTree(['customers', 'shipments-tracking', shipmentId]).toString();
          window.open(url, '_blank');
        } else {
          const detailModal = this.$modal.open(ShipmentTrackingDetailComponent, {
            windowClass: 'shipment-tracking-detail',
          });
          detailModal.componentInstance.purchaseOrder = this.purchaseOrder;
          detailModal.componentInstance.shipment = shipment;
          detailModal.componentInstance.companyType = this.companyType;
          detailModal.componentInstance.products = this.products
            .filter(p => this.purchaseOrder.line_items.find(item => item.product_id === p.id));
          detailModal.result
            .then(
              () => {
              },
              () => {
              },
            );
        }
      });
  }

  editShipment(shipmentId) {
    this.shipmentService.getShipmentPORelated(this.organizationId, this.purchaseOrder.id, shipmentId)
      .subscribe((shipment) => {
        const detailModal = this.$modal.open(ShipmentTrackingFormModalComponent, {
          size: 'lg',
          container: 'nb-layout',
        });
        detailModal.componentInstance.shipments = this.shipments;
        detailModal.componentInstance.purchaseOrder = this.purchaseOrder;
        detailModal.componentInstance.shipment = shipment;
        detailModal.componentInstance.companyType = this.companyType;
        detailModal.componentInstance.products = this.products.filter(p => this.purchaseOrder.line_items.find(item => item.product_id === p.id));
        detailModal.result
          .then(
            () => {
            },
            () => {
            },
          );
      });
  }

  private _shouldEnableShipments(po: PurchaseOrderDto): boolean {
    if (!po || !po.isApproved)
      return false;
    if (po.finished_goods_reports_period === 'No report needed')
      return po.isApproved;

    for (const item of po.report.items) {
      const reportExists = item.reports.some(x => x.quantity > 0);

      if (reportExists)
        return true;
    }

    return false;
  }
}
